module.exports = __webpack_public_path__ + "static/jelajah-hal-seru-2034688fc9971d34e678b8eb2cbcf3db.png";